import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "section-frame" }
const _hoisted_2 = { class: "section-frame__body" }
const _hoisted_3 = { class: "section-side" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "section-nav__list" }
const _hoisted_6 = {
  key: 2,
  class: "section-nav__sub"
}
const _hoisted_7 = { class: "section-frame__main" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import SectionMallBanner from '@/components/layout/SectionMallBanner.vue'
import { useAdminAuth } from '@/composables/useAdminAuth'
import {
  filterAdminOnlyNav,
  sideItemCurrent,
  type PortalSection,
  type PortalSideItem,
} from '@/constants/portalSections'


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionFrame',
  props: {
    section: {}
  },
  setup(__props: any) {

const props = __props
const route = useRoute()
const { isAdminLoggedIn } = useAdminAuth()

const visibleItems = computed(() => filterAdminOnlyNav(props.section.items, isAdminLoggedIn.value))
const current = computed(() => sideItemCurrent(route.path, visibleItems.value))

function isCurrent(item: PortalSideItem) {
  return current.value === item
}

function hasCurrentChild(item: PortalSideItem) {
  return item.children?.some((child) => isCurrent(child)) ?? false
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", {
          class: "section-nav",
          "aria-label": `${__props.section.label} 메뉴`
        }, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.to,
                class: "section-nav__item"
              }, [
                (item.disabled)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["section-nav__link is-disabled", { 'is-branch': hasCurrentChild(item) }])
                    }, _toDisplayString(item.label), 3))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: item.to,
                      class: _normalizeClass(["section-nav__link", { 'is-current': isCurrent(item), 'is-branch': hasCurrentChild(item) }])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"])),
                (item.children?.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: child.to
                        }, [
                          _createVNode(_component_router_link, {
                            to: child.to,
                            class: _normalizeClass(["section-nav__link section-nav__link--sub", { 'is-current': isCurrent(child) }])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(child.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ], 8, _hoisted_4),
        _createVNode(SectionMallBanner)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})